import { useParams } from "react-router";
import { ShopDetailView } from "@/features/shops/components/ShopDetailView";

export default function ShopDetailPage() {
  const { caseToken = "", shopId = "" } = useParams<{ caseToken: string; shopId: string }>();
  return <ShopDetailView caseToken={caseToken} shopId={shopId} />;
}
